import { render, staticRenderFns } from "./EventBuyTickets.vue?vue&type=template&id=4f17574f&"
import script from "./EventBuyTickets.vue?vue&type=script&lang=js&"
export * from "./EventBuyTickets.vue?vue&type=script&lang=js&"
import style0 from "./EventBuyTickets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports